(() => {
  const SELECTORS = [
    // Secciones completas (reveal suave)
    '.shopify-section:not(#shopify-section-header):not(#shopify-section-footer) .page-width',
    '.shopify-section:not(#shopify-section-header):not(#shopify-section-footer) .collection-list',
    '.shopify-section:not(#shopify-section-header):not(#shopify-section-footer) .featured-collection',
    '.shopify-section:not(#shopify-section-header):not(#shopify-section-footer) .multicolumn',
    '.shopify-section:not(#shopify-section-header):not(#shopify-section-footer) .image-with-text',
    '.shopify-section:not(#shopify-section-header):not(#shopify-section-footer) .rich-text',
    '.shopify-section:not(#shopify-section-header):not(#shopify-section-footer) .slideshow'
  ];

  const STAGGER_SELECTORS = [
    // Grids / cards (stagger)
    '.collection-list .grid',
    '.featured-collection .grid',
    '.multicolumn .multicolumn-list',
    '.product-grid',
    '.grid'
  ];

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const markOnce = (el, className) => {
    if (!el || el.dataset.srDone === '1') return;
    el.classList.add(className);
    el.dataset.srDone = '1';
  };

  // Añadimos clases iniciales
  const revealTargets = new Set();
  SELECTORS.forEach(sel => document.querySelectorAll(sel).forEach(el => revealTargets.add(el)));
  revealTargets.forEach(el => el.classList.add('sr'));

  const staggerTargets = new Set();
  STAGGER_SELECTORS.forEach(sel => document.querySelectorAll(sel).forEach(el => staggerTargets.add(el)));
  staggerTargets.forEach(el => el.classList.add('sr-stagger'));

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      el.classList.add('is-in');
      io.unobserve(el);
    });
  }, {
    root: null,
    threshold: 0.18,
    rootMargin: '0px 0px -10% 0px'
  });

  // Observa ambos tipos
  document.querySelectorAll('.sr, .sr-stagger').forEach(el => io.observe(el));

  // Shopify: cuando cambias secciones en editor / ajax, re-scan (safe)
  document.addEventListener('shopify:section:load', () => location.reload());
})();
